import actions from './actions'
import getters from './getters'
import { mutations } from './mutations'

// Full default state - restored by resetExternalState on admin/office login
const defaultState = () => ({
    userTypeList: [],
    users: [],
    farmerUserDetails: null
})

const state = defaultState()

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations: Object.assign({}, mutations, {
    resetExternalState (state) {
      Object.assign(state, defaultState())
    }
  })
}
